<div layout-horizontal layout-space-between padding class="rt-card rt-card-background-light">
  <div layout-vertical>
    <rt-heading>
      <rt-truncate>
        {{ invitation.email }}
      </rt-truncate>
    </rt-heading>
    <rt-date [time]="invitation.createdAt" variant="left-align"> </rt-date>
  </div>

  @if (!readOnly) {
    <rt-group layout-justify-flex-end layout-align-items-center class="button-group">
      <rt-button variant="tertiary" (click)="resendInvitation.emit(invitation)">
        <rt-icon name="mail"></rt-icon>
        <span>{{ 'app.memberships.resend_invitation' | translate }}</span>
      </rt-button>
      <rt-button variant="tertiary" (click)="deleteClick.emit(invitation)">
        <rt-icon name="delete"></rt-icon>
        <span>{{ 'app.common.delete' | translate }}</span>
      </rt-button>
    </rt-group>
  }
</div>
